import { useEffect } from 'react';

const DEFAULT_SITE_NAME = 'Risqly Cybersecurity';
const DEFAULT_DESCRIPTION = 'Risqly Cybersecurity - Network-based vendor cybersecurity risk assessment';

function getOrCreateMetaTag(attribute, value) {
  const selector = `meta[${attribute}="${value}"]`;
  let meta = document.head.querySelector(selector);

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, value);
    document.head.appendChild(meta);
  }

  return meta;
}

function getOrCreateCanonicalLink() {
  let canonical = document.head.querySelector('link[rel="canonical"]');

  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }

  return canonical;
}

export default function usePageMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  noindex = false,
}) {
  useEffect(() => {
    if (!title) {
      document.title = DEFAULT_SITE_NAME;
    } else {
      document.title = title === DEFAULT_SITE_NAME || title.includes(DEFAULT_SITE_NAME)
        ? title
        : `${title} | ${DEFAULT_SITE_NAME}`;
    }

    const descriptionMeta = getOrCreateMetaTag('name', 'description');
    descriptionMeta.setAttribute('content', description);

    const ogTitleMeta = getOrCreateMetaTag('property', 'og:title');
    ogTitleMeta.setAttribute('content', document.title);

    const ogDescriptionMeta = getOrCreateMetaTag('property', 'og:description');
    ogDescriptionMeta.setAttribute('content', description);

    const canonical = getOrCreateCanonicalLink();
    canonical.setAttribute('href', window.location.href);

    const robotsMeta = getOrCreateMetaTag('name', 'robots');
    robotsMeta.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');
  }, [title, description, noindex]);
}